import * as React from "react";

import Button from 'src/SharedComponents/Button';
import Dialog from 'src/SharedComponents/Dialog/Dialog';
import DialogActions from 'src/SharedComponents/Dialog/DialogActions';
import DialogContent from 'src/SharedComponents/Dialog/DialogContent';
import DialogContentText from 'src/SharedComponents/Dialog/DialogContentText';
import DialogTitle from 'src/SharedComponents/Dialog/DialogTitle';

interface IProps {
    onExtendSession: () => void,
    onEndSession: () => void
}

interface IState {
    secondsRemining: number
}

class SessionExpiredDialog extends React.Component<IProps, IState>{
    private interval: NodeJS.Timeout | null;
    constructor(props: any) {
        super(props);
        this.state = {
            secondsRemining: 60
        }
        this.interval = null;
        this.continueSession = this.continueSession.bind(this);
        this.updateSecondsOrExpireSession = this.updateSecondsOrExpireSession.bind(this);
    }

    public componentDidMount() {
        this.interval = setInterval(this.updateSecondsOrExpireSession, 1000);
    }

    public componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    public render() {
        return <Dialog open={true} onClose={this.props.onEndSession} preventClickOutsideClose={true}>
            <DialogTitle className="DialogTitle">Your session expires soon</DialogTitle>
            <DialogContent className="DialogContent">
                <DialogContentText className="DialogContentText">Your session will expire in {this.state.secondsRemining} {this.state.secondsRemining > 1 ? "seconds" : "second"}. Do you wish to continue using IMX-CR?</DialogContentText>
            </DialogContent>
            <DialogActions className="DialogActions">
                <Button margin="0px 4px" onClick={this.continueSession} plain={true}>Yes, keep me signed in</Button>
                <Button margin="0px 4px" onClick={this.props.onEndSession} plain={true}>No, sign me out</Button>
            </DialogActions>
        </Dialog>
    };

    private continueSession() {
        if (this.interval) {
            clearInterval(this.interval);
        }
        this.props.onExtendSession();
    }

    private updateSecondsOrExpireSession() {
        if (this.state.secondsRemining === 0) {
            this.props.onEndSession();
        } else {
            this.setState({
                ...this.state,
                secondsRemining: this.state.secondsRemining - 1
            })
        }

    }
}

export default SessionExpiredDialog;
